<template>
  <div style="flex-flow:column; position:relative">
    <user-token-site-info :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <el-input
      :placeholder="sns_type == 'youtube' ? 'チャンネル名で検索' : 'ユーザー名で検索'"
      class="side-search-form-input"
      :class="dark_mode ? 'dark' : ''"
      :value="name"
      @focus="focus()"
      @input="suggestInfluencer($event)"
      @blur="suggest_on ? '' : (suggest_show = false) & (suggest_hover = -1)"
      @keydown.up.native="suggestHover('up')"
      @keydown.down.native="suggestHover('down')"
      @keydown.enter.native="suggestEnter()"
      clearable
      size="mini"
    ></el-input>
    <div class="request-pr-form-suggest sidemenu" id="influencer-box" v-if="suggest_show && name != ''" :class="[suggest_influencer.length > 7 ? 'scroll' : '', dark_mode ? 'dark' : '']">
      <div
        class="request-pr-form-suggest-box"
        v-for="(suggest, index) in suggest_influencer"
        :key="suggest.id"
        v-show="name != '' || suggest_loading"
        :class="[suggest_hover == index ? 'hover' : '', dark_mode ? 'dark' : '']"
        @click="suggestClick(index)"
        @mouseover="suggest_on = true"
        @mouseleave="suggest_on = false"
      >
        <el-image :src="suggest.profile_picture_url" class="request-pr-form-suggest-image">
          <div slot="error" class="data-table-profile-noimg">
            NO
            <br />IMAGE
          </div>
        </el-image>
        <div class="flex-column">
          <div :style="dark_mode ? 'color:#fff' : ''">
            {{ suggest.account_name }}
            <img src="../../assets/badge.png" style="width:10px; height:10px; margin-left:3px" v-show="suggest.badge" />
            <font-awesome-icon :icon="['fas', 'check-circle']" v-show="suggest.verified && sns_type == 'tiktok'" class="tt-badge small" />
            <font-awesome-icon :icon="['fas', 'badge-check']" v-show="suggest.verified && sns_type == 'twitter'" class="tw-badge small" />
          </div>
          <div class="suggest-box-name">{{ suggest.name }}</div>
        </div>
      </div>
      <div class="request-pr-form-suggest-box side-nolist" :class="dark_mode ? 'dark' : ''" v-if="suggest_influencer.length == 0 && name && name.length >= suggestMinLength">
        <div class="loader--mini" :class="dark_mode ? '' : 'blue'" v-if="suggest_loading"></div>
        <span v-else>{{ siteName }} に登録されていません</span>
      </div>
    </div>
  </div>
</template>

<script>
import UserTokenSiteInfo from "@/components/oem/UserTokenSiteInfo.vue";

const root = process.env.VUE_APP_API;
const suggestInfluencerAPI = root + "/api/report/suggest_influencer";
const SUGGEST_MIN_LENGTH = 2;
const SUGGEST_DEBOUNCE_MS = 500;

export default {
  name: "SidemenuSuggestInfluencer",
  props: ["sns_type", "name"],
  components: {
    UserTokenSiteInfo,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      suggestMinLength: SUGGEST_MIN_LENGTH,
      suggestDebounceMs: SUGGEST_DEBOUNCE_MS,
      influencer_index: "",
      suggest_influencer: [],
      suggest_list: [],
      suggest_loading: false,
      suggest_show: false,
      suggest_hover: -1,
      suggest_on: false,
      requestId: +new Date(),
      suggestDebounceTimer: null,
      siteName: "REECH DATABASE"
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    this.clearSuggestDebounceTimer();
  },
  methods: {
    clearSuggestDebounceTimer() {
      if (this.suggestDebounceTimer) {
        clearTimeout(this.suggestDebounceTimer);
        this.suggestDebounceTimer = null;
      }
    },
    focus() {
      this.suggest_show = true;
      this.suggestInfluencer(this.name);
    },
    suggestInfluencer(value) {
      this.$emit("update:name", value);
      this.suggest_show = true;
      this.suggest_hover = -1;
      this.clearSuggestDebounceTimer();
      this.axios.cancel(this.requestId);

      if (!value || value.length < this.suggestMinLength) {
        this.suggest_loading = false;
        this.suggest_influencer = [];
        return;
      }

      this.suggest_loading = true;
      this.suggestDebounceTimer = setTimeout(() => {
        this.fetchSuggestInfluencer(value);
      }, this.suggestDebounceMs);
    },
    fetchSuggestInfluencer(value) {
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.axios
          .get(suggestInfluencerAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              sns_type: this.sns_type,
              influencer: value,
            },
          })
          .then((response) => {
            this.suggest_influencer = response.data;
            this.suggest_loading = false;
          })
          .catch(() => {
            this.suggest_loading = false;
          });
    },
    suggestHover(type) {
      if (type == "up") {
        if (this.suggest_hover == -1) {
          this.suggest_hover += 0;
        } else {
          this.suggest_hover -= 1;
        }
      } else if (type == "down") {
        if (this.suggest_hover == this.suggest_influencer.length - 1) {
          this.suggest_hover += 0;
        } else {
          this.suggest_hover += 1;
        }
      }
      var suggest_position = 51;
      var target = document.getElementById("influencer-box");
      if (target) target.scrollTop = (this.suggest_hover - 5) * suggest_position;
    },
    suggestClick(index) {
      this.$emit("update:name", this.suggest_influencer[index].account_name);
      this.suggest_show = false;
      this.$emit("nameSearch");
    },
    suggestEnter() {
      if (this.suggest_hover >= 0) {
        this.$emit("update:name", this.suggest_influencer[this.suggest_hover].account_name);
        this.suggest_show = false;
        this.$emit("nameSearch");
      }
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  },
  watch: {
    name() {
      this.$emit("resultCount");
    },
  },
  filters: {},
};
</script>
